import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  contactsModalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    backgroundColor: "#FFF",
    width: "70vw",
    transform: "translate(-50%, -50%)",
    borderRadius: "12px",
    overflow: "auto",

    "& input.input-form-content": {
      border: "1px solid #E4E7EC",
      borderRadius: "8px",
      padding: "9px 16px",
      color: "#465869",
      fontWeight: 500,
      fontSize: "14px"
    },

    "& select": {
      border: "1px solid #E4E7EC",
      borderRadius: "8px",
      padding: "8px 16px",
      backgroundColor: "#FFFFFF",
      color: "#465869",
      fontWeight: 500,
      fontSize: "14px"
    },

    "& span.label": {
      fontWeight: 600,
      fontSize: "14px",
      color: "#308CDB"
    }
  },

  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal"
  },

  modalSection: {
    padding: "1.5rem",
    paddingTop: 0,
    "&.fullForm": {
      maxHeight: "55vh",
      overflowY: "auto"
    }
  }
}));

export default styles;
